import { Controller } from "@hotwired/stimulus"
import api from "../utils/api"

export default class extends Controller {
  static targets = ["previewContent"]
  static values = {
    extId: String,
    postExtId: String,
    spaceUrl: String,
    loaded: Boolean
  }

  connect() {
    this.loadedValue = false
  }

  async loadEditorData(event) {
    // 이미 로드되었으면 스킵
    if (this.loadedValue) return

    // 로딩 중 버튼 비활성화
    const button = event.currentTarget
    button.disabled = true
    button.style.cursor = "wait"

    try {
      // api.get을 사용하되, Turbo Stream을 위한 커스텀 헤더 추가
      const response = await api.get(
        `/${this.spaceUrlValue}/o/notes/${this.postExtIdValue}/post_history_detail`,
        { history_ext_id: this.extIdValue },
        { 'Accept': 'text/vnd.turbo-stream.html' }
      )

      // axios response는 .data에 실제 내용이 있음
      if (response.status === 200) {
        // Turbo Stream HTML 응답 처리
        Turbo.renderStreamMessage(response.data)

        this.loadedValue = true

        // notes--draft 컨트롤러에 editor_data 설정
        const draftController = this.element.querySelector('[data-controller*="notes--draft"]')
        if (draftController) {
          // editor_data가 로드되면 turbo_stream에서 처리됨
        }
      } else {
        throw new Error(`Failed to load: ${response.status}`)
      }
    } catch (error) {
      console.error('Failed to load history data:', error)

      // 에러 메시지 표시
      if (this.hasPreviewContentTarget) {
        this.previewContentTarget.innerHTML = `
          <div class="text-center p-8 text-red-500">
            <p>버전 정보를 불러올 수 없습니다.</p>
            <button class="mt-2 text-blue-500 underline" data-action="click->post-history-item#retryLoad">재시도</button>
          </div>
        `
      }
    } finally {
      // 버튼 다시 활성화
      button.disabled = false
      button.style.cursor = ""
    }
  }

  retryLoad(event) {
    event.preventDefault()
    this.loadedValue = false

    // 로딩 스피너 다시 표시
    if (this.hasPreviewContentTarget) {
      this.previewContentTarget.innerHTML = `
        <div class="flex items-center justify-center p-8">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 dark:border-gray-100"></div>
        </div>
      `
    }

    // 재시도
    const button = document.getElementById(`modalButton${this.extIdValue}`)
    if (button) {
      button.click()
    }
  }

  async recoverWithData(event) {
    // 데이터가 로드되지 않았다면 먼저 로드
    if (!this.loadedValue) {
      await this.loadEditorData(event)
    }
    // notes--draft 컨트롤러가 실제 복원 처리
  }
}